import { Component } from '@angular/core';

@Component({
    selector: 'asg-pure-spinner',
    templateUrl: './pure-spinner.component.html',
    styleUrls: ['./pure-spinner.component.scss'],
    standalone: true
})
export class PureSpinnerComponent {}
